import React from 'react';
import '../styles/Instrumentos.css';
/*Documentos*/
import ROF_pdf from '../documentos/instrumentos/ROF.pdf';
import MAPRO_pdf from '../documentos/instrumentos/MAPRO.pdf';
import MPP_pdf from '../documentos/instrumentos/MPP.pdf';
import MOF_pdf from '../documentos/instrumentos/MOF.pdf';
import TUPA_pdf from '../documentos/instrumentos/TUPA.pdf';
import PAP_pdf from '../documentos/instrumentos/PAP.pdf';
import CAP_pdf from '../documentos/instrumentos/CAP.pdf';
import RIT_pdf from '../documentos/instrumentos/RIT.pdf';
import PDLC_pdf from '../documentos/instrumentos/PDLC.pdf';
import MCC_pdf from '../documentos/instrumentos/MCC.pdf';
import TUSNE_pdf from '../documentos/instrumentos/TUSNE.pdf';
import COD_ETICA_PDF from '../documentos/instrumentos/CODIGO_DE_ETICA.pdf';
import PLAN_CONTINUIDAD from '../documentos/instrumentos/PLAN_DE_CONTINUIDAD_OPERATIVA.pdf';

/*Iconos*/
import pdf_icon from '../imagenes/icons/pdf.gif';

function Instrumentos(){
    const documentos = [
        {
            titulo: 'Reglamento de Organizaciones y Funciones - ROF',
            url: ROF_pdf,
        }, 
        {
            titulo: 'Manual de Procedimientos - MAPRO',
            url: MAPRO_pdf,
        },
        {
            titulo: 'Manual de Perfiles de Puestos - MPP',
            url: MPP_pdf,
        }, 
        {
            titulo: 'Manual de Organizaciones y Funciones - MOF',
            url: MOF_pdf,
        }, 
        {
            titulo: 'Manual de Clasificador de Cargos - MCC',
            url: MCC_pdf,
        },
        {
            titulo: 'Texto Único de Procedimientos Administrativos - TUPA',
            url: TUPA_pdf,
        }, 
        {
            titulo: 'Presupuesto Analítico del Personal - PAP',
            url: PAP_pdf,
        }, 
        {
            titulo: 'Cuadro de Asignación del Personal - CAP',
            url: CAP_pdf,
        },
        {
            titulo: 'Reglamento Interno del Trabajo - RIT',
            url: RIT_pdf,
        },
        {
            titulo: 'Plan de Desarrollo Local Concertado - PDLC',
            url: PDLC_pdf,
        }, 
        {
            titulo: 'Texto Unico de Servicios no Exclusivos - TUSNE',
            url: TUSNE_pdf,
        }, 
        {
            titulo: 'Código de Ética - MPCH',
            url: COD_ETICA_PDF,
        }, 
        {
            titulo: 'Plan de Continuidad Operativa 2024 - 2026',
            url: PLAN_CONTINUIDAD,
        }
    ];
    return(
        <div className="galeria-container">
            <h2>Instrumentos de Gestión</h2>
            <div className="pdf-grid">
                {documentos.map((doc, index) => (
                <div className="pdf-card" key={index}>
                    <img src={pdf_icon} className="pdf-icon"></img>
                    <h3>{doc.titulo}</h3>
                    <a
                    href={doc.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ver-btn"
                    >
                    Ver Documento
                    </a>
                </div>
                ))}
            </div>
        </div>
    );
};
export default Instrumentos;